export default "__VITE_ASSET__f8558a92__"